<ng-container *ngIf="isLoading$ | async"></ng-container>
<ngx-spinner></ngx-spinner>
<div class="page-title-area page-title-four">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="page-title-item">
        <h2> {{'MENU.SURVEY' | translate}} </h2>
        <ul>
          <li><a routerLink="/">{{'MENU.HOME' | translate}}</a></li>
          <li><i class="icofont-simple-right"></i></li>
          <li>{{'MENU.SURVEY' | translate}}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="appointment-area-two" style="margin-top: 20px;margin-bottom: -115px;">
  <div class="container">
    <div class="row text-center" style="margin: 40px 0px;">
      <h1>{{ language == 'en'? 'Submit Your Survey':'إرسال الاستطلاع الخاص بك'}}</h1>
    </div>

    <div class="row align-items-center appointment-wrap-two">
      <div class="col-lg-12 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
        <div class="appointment-item appointment-item-two ">
          <form [formGroup]="sectionsForm" (ngSubmit)="onSubmit()">
            <div formArrayName="sections" *ngFor="let section of sections.controls; let sectionIndex = index">
              <div [formGroupName]="sectionIndex" class="card mb-3">
                <div class="card-header text-center">
                 <h4> {{ section.get('sectionTitle').value }}</h4>
                </div>
                <div class="card-body">
                  <div formArrayName="questions"
                    *ngFor="let question of getQuestions(sectionIndex).controls; let questionIndex = index">
                    <div [formGroupName]="questionIndex" class="form-group row">
                      <label class="col-sm-12 col-form-label">{{ question.get('questionText').value }}</label>
                      <div class="col-sm-12 text-center">
                        <ngb-rating [(rate)]="getQuestions(sectionIndex).at(questionIndex).value.answer"
                          (rateChange)="setAnswer(sectionIndex, questionIndex, $event)" [starTemplate]="t"
                          [max]="5"></ngb-rating>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row text-center" style="margin: 40px 0px;">
              <h3>{{ language == 'en'? 'Notes':'ملاحظات' }}</h3>
              <textarea style="height: 200px !important;" rows="100" class="form-control"
                formControlName="Notes" [class.is-invalid]="isControlInvalid('Notes')"
                [class.is-valid]="isControlValid('Notes')"></textarea>
                <div class="invalid-feedback ValidateText"
                *ngIf="(sectionsForm.value.Notes?.length > 4000) && !controlHasError('pattern', 'Notes')">
                {{ 'AUTH.VALIDATION.MAX_LENGTH'| translate : {'max':4000} }}
                </div>
                <div class="invalid-feedback ValidateText" *ngIf="controlHasError('pattern', 'Notes')">
                {{ 'AUTH.VALIDATION.INVALID'| translate : {'name':language == 'en'? 'Notes':'ملاحظات' } }}
                </div>
            </div>
            <div class="row text-center">
              <button type="submit" class="btn btn-primary">{{ 'COMMON.SUBMMIT' | translate }}</button>
            </div>
          </form>

          <ng-template #t let-fill="fill">
            <span class="star" [class.filled]="fill === 100" [class.empty]="fill !== 100">&#9733;</span>
          </ng-template>
        </div>
      </div>
    </div>

  </div>
</div>